import 'github-markdown-css/github-markdown.css';
import darkTheme from './github-markdown-dark';

let styleNode;

if (typeof window !== 'undefined') {
    styleNode = document.createElement('style');
    if (document.head) {
        document.head.appendChild(styleNode);
    }
}

export default function setMarkdownTheme(theme) {
    styleNode.textContent = theme === 'dark' ? darkTheme : '';
}
